import Action from '../../classes/Action';
import Engine from '../../classes/Engine';
import BaseTool from '../../classes/tools/BaseTool';

export default class RemoveToolAction extends Action
{
	constructor(tool : BaseTool)
	{
		const actionName = "Removed " + tool.name;
		super([tool], [tool], actionName, [tool]);
	}

	do(tool: BaseTool)
	{
		Engine.getInstance().getToolsManager().removeTool(tool);
	}

	undo(tool: BaseTool)
	{
		Engine.getInstance().getToolsManager().addTool(tool);
	}

	verify(tool: BaseTool): boolean
	{
		return tool !== undefined && tool !== null;
	}
}
